module.exports = __webpack_public_path__ + "static/img/airTax.61a05cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/airTax.png
// module id = Eswc
// module chunks = 34